import { theme } from 'antd';

export const liteTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // screenXSMin: '400px',
    // screenSM: '500px',
    // screenMD: '768px',
    // screenLG: '1024px',
    // screenXL: 1500,
    screenXXLMin: 1900,
    screenXXL: 2000,
    colorPrimary: '#3390ec', // Telegram-акцент
    colorSuccess: '#2ec971',
    colorError: '#f6465d',
    colorWarning: '#f0b90b',
    colorInfo: '#3390ec',

    colorTextBase: '#1e1f22',
    colorTextSecondary: '#6c757d',
    colorTextPlaceholder: '#adb5bd',

    colorBgBase: '#f5f6fa', // общий фон страницы
    colorBgContainer: '#ffffff', // карточки, таблицы
    colorBorder: '#dee2e6', // границы и разделители
    colorSplit: '#e9ecef',
    fontFamily: `'Inter', 'Roboto', 'Segoe UI', sans-serif`,
  },

  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#f5f6fa',
      footerBg: '#ffffff',
      headerColor: '#1e1f22',
      siderBg: '#f0f2f5',
      triggerBg: '#ffffff',
      triggerColor: '#1e1f22',
      triggerHoverBg: '#f5f6fa',
    },

    Menu: {
      itemBg: '#ffffff',
      itemColor: '#1e1f22',
      itemHoverColor: '#3390ec',
      itemHoverBg: '#f0f4f8',
      itemSelectedColor: '#3390ec',
      itemSelectedBg: '#e6f0fb',
    },

    Button: {
      colorPrimary: '#3390ec',
      colorPrimaryHover: '#4fa7ff',
      colorPrimaryActive: '#2a75cc',
      defaultBg: '#ffffff',
      defaultHoverBg: '#f0f2f5',
      colorText: '#1e1f22',
    },

    Input: {
      colorBgContainer: '#ffffff',
      colorText: '#1e1f22',
      colorTextPlaceholder: '#adb5bd',
      colorBorder: '#dee2e6',
      activeShadow: '0 0 0 2px rgba(51, 144, 236, 0.2)',
    },

    Card: {
      colorBgContainer: '#ffffff',
      colorText: '#1e1f22',
      colorBorder: '#dee2e6',
    },

    Drawer: {
      colorBgElevated: '#ffffff',
      headerBg: '#ffffff',
      footerBg: '#ffffff',
      colorText: '#1e1f22',
      colorTextHeading: '#1e1f22',
      colorIcon: '#6c757d',
    },

    Table: {
      colorBgContainer: '#ffffff',
      headerBg: '#f8f9fa',
      headerColor: '#6c757d',
      colorText: '#1e1f22',
      rowHoverBg: '#f0f4f8',
      borderColor: '#dee2e6',
    },

    Tooltip: {
      colorBgSpotlight: '#1e1f22',
      colorTextLightSolid: '#ffffff',
    },

    Select: {
      colorBgContainer: '#ffffff',
      colorText: '#1e1f22',
      optionSelectedColor: '#3390ec',
      optionSelectedBg: '#e6f0fb',
    },

    Pagination: {
      itemBg: '#ffffff',
      itemLinkBg: '#ffffff',
      colorText: '#1e1f22',
      colorPrimary: '#3390ec',
    },

    Tabs: {
      itemColor: '#1e1f22',
      itemHoverColor: '#3390ec',
      itemSelectedColor: '#3390ec',
      inkBarColor: '#3390ec',
    },

    Alert: {
      colorInfoBg: '#e6f0fb',
      colorSuccessBg: '#e6f9f0',
      colorWarningBg: '#fffbe6',
      colorErrorBg: '#ffe6e6',
      colorText: '#1e1f22',
    },

    Collapse: {
      headerBg: '#f8f9fa',
      contentBg: '#ffffff',
    },

    Divider: {
      colorSplit: '#dee2e6',
    },

    Switch: {
      colorPrimary: '#3390ec',
      colorBgContainer: '#e9ecef',
      handleBg: '#ffffff',
    },

    Steps: {
      colorPrimary: '#3390ec',
      colorText: '#1e1f22',
    },

    Tag: {
      colorBgContainer: '#e9ecef',
      colorText: '#1e1f22',
    },

    Progress: {
      remainingColor: '#e9ecef',
    },

    Slider: {
      trackBg: '#3390ec',
      railBg: '#dee2e6',
    },
  },
};
